export function getOffsets(wrapperRef /*, imgRef*/) {
  let base = {left: 0, top: 0, right: 0, bottom: 0}
  let {left, top, right, bottom} = wrapperRef.current?.getBoundingClientRect() || base
  bottom = window.innerHeight - bottom
  right = window.innerWidth - right
  return [top, left, bottom, right]
}
